export default __webpack_public_path__ + "static/media/quote-icon-4.7a6218f2.svg";